import React, { useState, useEffect } from "react";
import Notifications from "../Admin-Dashboard-Component/Comman/Notifications"
import { FiBookOpen, FiUserCheck, FiAlertTriangle,FiAlertCircle } from "react-icons/fi";
import './StudentNotifications.css';

const initialStudentNotifications = [
  {
    id: 1,
    type: "exam",
    message: "Results out: Biology Test",
    time: "2 hours ago",
    read: false,
    icon: <FiBookOpen />,
  },
  {
    id: 2,
    type: "announcement",
    message: "New announcement: Library timings updated",
    time: "Today",
    read: false,
    icon: <FiAlertTriangle />,
  },
  {
    id: 3,
    type: "profile",
    message: "Your profile has been approved",
    time: "Yesterday",
    read: true,
    icon: <FiUserCheck />,
  },
  {
    id: 4,
    type: "exam",
    message: "New practice quiz available: Algebra Basics",
    time: "30 minutes ago",
    read: false,
    icon: <FiBookOpen />,
  },
  {
    id: 5,
    type: "alert",
    message: "Attendance below 75% in Physics",
    time: "2 days ago",
    read: false,
    icon: <FiAlertCircle />,
  },
  {
    id: 6,
    type: "exam",
    message: "Assignment deadline extended: English Essay",
    time: "3 hours ago",
    read: true,
    icon: <FiBookOpen />,
  },

  {
    id: 7,
    type: "alert",
    message: "New announcement: Parent-teacher meeting on Friday",
    time: "Today at 12:30 PM",
    read: false,
    icon: <FiAlertCircle />,
  },
  {
    id: 8,
    type: "exam",
    message: "Science Fair registration is now open",
    time: "1 day ago",
    read: true,
    icon: <FiBookOpen />,
  },


];

const StudentNotifications = () => {
  const [notifications, setNotifications] = useState(initialStudentNotifications);

  const handleMarkAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true } : n))
    );
  };

  const handleMarkAllAsRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
  };

  return (
    <Notifications
      title="Student Notifications"
      notifications={notifications}
      onMarkAllAsRead={handleMarkAllAsRead}
      onMarkAsRead={handleMarkAsRead}
    />
  );
};

export default StudentNotifications;
